module.exports = __webpack_public_path__ + "static/13-7abd195884b7e0dea5b255d13af3f427.jpg";